import { useCallback, useReducer } from 'react';
import { flushSync } from 'react-dom';
import { useCurrent } from './useCurrent';
import { useStableCallback } from './useStableCallback';
import { queueMicrotask } from './queueMicrotask';
function basicStateReducer(state, action) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return typeof action === 'function' ? action(state) : action;
}
export function useControlledValue({ value, onChange, reducer = basicStateReducer, defaultValue, }) {
    const [state, dispatch] = useReducer(reducer, defaultValue);
    const stateRef = useCurrent(state);
    const valueRef = useCurrent(value);
    const stableOnChange = useStableCallback(onChange);
    const dispatchWithOnchange = useCallback((action) => {
        if (typeof valueRef.current !== 'undefined') {
            stableOnChange(reducer(valueRef.current, action));
        }
        else {
            // moving this inside of a microtask because of the issue outlined in PDDS-332
            queueMicrotask(() => {
                flushSync(() => {
                    dispatch(action);
                });
                stableOnChange(stateRef.current);
            });
        }
    }, [reducer, stableOnChange, stateRef, valueRef]);
    return [typeof value !== 'undefined' ? value : state, dispatchWithOnchange];
}
//# sourceMappingURL=useControlledValue.js.map